import React, { Component } from 'react';
import Parser from 'html-react-parser';
import {loginRedirect} from './../common/Util'
import {errorRedirect} from './../common/Util'

class MyApis extends Component {

	constructor(props) {
		super(props);
		this.state = {
				crafterResponse:''
		};
	}

	componentDidMount() {
	 this.getApis();
	}

	getApis() {
    	return fetch(process.env.REACT_APP_HOST_API_URL + "/developer/mvc/api/contentFetcher?path=managemyaccount/firstnet/myapis", {
	        headers: {
	          'Content-Type': 'text/html; charset=UTF-8'
	        },
	        credentials: 'include',
	        method: 'GET'
	      })
	      .then(response=> {
	        if (!response.ok) {
	          console.log("response is not ok " + response.statusText  + " with status of " + response.status);
	          if(response.status === 401) {
	        	  loginRedirect();
	          } else {
	          	throw new Error("Unknown error occurred : " + response.statusText);
	          }
	        }
	      	return response.text();
	      })
	      .then(crafterResponseText=> {
	    	  this.setState({crafterResponse: crafterResponseText});
	      })
	      .catch(error=> {
	          console.log("Error geting APIs from server: " + error);
	          errorRedirect("request.processing.error");
	      });
	}

    render() {
        return(
            <div className="col-12" id="my_apis_page">
                <div className="row py-4">
                    <div className="col-12">
                        <h1 id="myAPIMainHeading"><i className="fa fa-code sideNavIcon" /> My Apis</h1>
                    </div>
                </div>
                <div id="crafterDataContainer" className="row pb-4">
                    {Parser(this.state.crafterResponse)}
                </div>
            </div>
        )
    }
}

export default MyApis;


// WEBPACK FOOTER //
// ./src/manageMyAccount/MyApis.js